import { Dna } from "react-loader-spinner";
import { Wrapper } from "../../components/styles";

const CircularLoader: React.FC = () => {
  return (
    <Wrapper >
        <Dna  />
    </Wrapper>
  )
}

export default CircularLoader
